<template>
  <v-page page="Account Summary" :breadcrumb="breadcrumb">
    <!--Spinner ref="spinner"></Spinner-->
    <v-container ma-0 px-3 pt-0 pb-0>
      <v-layout mt-5 mx-2>
        <v-divider
          class="mt-3"
          style="font-size:25px!important;border-width:2px!important;"
          :style="{'border-color':account.AccountStatusColor}"
        ></v-divider>
      </v-layout>
      <v-layout text-xs-center>
        <v-flex mb-0 xs12 mx-2>
          <v-layout justify-center row align-center>
            <v-flex pa-0>
              <div pa-0>
                <v-layout justify-start row align-center mt-2 mb-0 style="min-height: 46px;">
                  <v-flex align-center>
                    <editAccount ref="editAccount"></editAccount>
                    <manageContacts ref="manageContacts"></manageContacts>
                    <!-- START OF TOP PANEL -->
                    <v-layout row>
                      <!-- START OF TOP 1ST COLUMN -->
                      <v-flex justify-start mr-5 xs4 style="margin-right: 50px;">
                        <v-layout style="border-bottom: 1px solid #E0E0E0">
                          <v-flex
                            class="text-xs-left align-center"
                            style="font-size: 20px; font-weight: 600;"
                          >Account # {{ BAN }}</v-flex>
                          <v-flex fill-height>
                            <v-layout justify-end align-end fill-height style="padding-top:7px">
                              <router-link style="text-decoration:none" class="mr-3" :to="openAuditLogs()">LOG</router-link>
                              
                              <router-link style="text-decoration:none" :to="openEditAccountRoute()">EDIT</router-link>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                          <v-container fluid grid-list-sm pa-0>
                        <v-layout justify-start row wrap>
                          <v-flex d-flex>
                            <!-- <div
                              class="text-xs-left align-center"
                              style="font-size: 20px; font-weight: 600;"
                            >Account # {{ BAN }}</div>-->
                            <v-layout style="margin-top:4px">
                              <v-flex style="text-align: left; font-size: 12px; ">
                                <strong>{{ account.Name1 + ' ' + (account.Name2 ? account.Name2 : '') }}</strong>
                                <br />
                                {{ account.Address1 }}
                                <br />
                                {{ account.Address2 ? account.Address2 : '' }}
                                <br v-show="account.Address2" />
                                {{ account.cityName + ', ' + account.stateProv + ' ' + account.mailCode }}
                                <br />
                                {{ account.countryName | uppercase }}
                                <br />
                                <span>Type:</span>&nbsp;
                                <span style="color: red;">{{ account.accountType }}</span>
                                <br />
                                <span>Class:</span>&nbsp;<span class="font-weight-bold">{{ account.accountClass }}</span>
                                <br />
                                <v-layout row>
                                  <v-flex shrink class="py-0">Status:&nbsp;</v-flex>
                                  <v-flex
                                    class="font-weight-bold py-0"
                                    :style="{'color':account.AccountStatusColor}"
                                  >{{ account.AccountStatus | uppercase }}</v-flex>
                                </v-layout>
                                 <v-layout row v-if="(account.IsChild) || (account.IsParent)" >
                                  <v-flex shrink class="py-0">A/R Owned By:&nbsp;</v-flex>
                                  <v-flex
                                    class="font-weight-bold py-0"
                                  >{{ account.arOwnedBy | uppercase }}</v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs4 class="fill-height d-flex stretch child-flex">
                            <v-layout justify-end column>
                              <v-flex>
                              <v-autocomplete
                                :items="account.ddlStatusActions"
                                v-model="account.statusAction"
                                item-text="Text"
                                item-value="Value"
                                class="caption"
                                @change="updateStatusAction"
                              >
                                <template slot="label">
                                  <div class="red--text">Status Action</div>
                                </template>
                              </v-autocomplete>
                            </v-flex>
                             <v-flex mt-0 style="padding-top:38px;" v-if="account.IsChild" class="fill-height align-end justify-end text-xs-right" >
                              <br />
                              <router-link style="text-decoration:none" :to="goToParent()">GO TO PARENT</router-link>
                            </v-flex>

                            <v-flex mt-0 style="padding-top:38px;" v-if="account.IsParent" class="fill-height align-end justify-end text-xs-right">
                              <br />
                              <router-link style="text-decoration:none" :to="goToChild()">GO TO SUB</router-link>
                            </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                          </v-container>
                      </v-flex>
                      <!-- END OF TOP 1ST COLUMN -->
                      <!-- START OF TOP 2ND COLUMN -->
                      <v-flex justify-start mr-5 xs4 style="margin-right: 50px;">
                        <v-layout
                          style="border-bottom: 1px solid #E0E0E0; padding-top:7px;padding-bottom:2px"
                        >
                          <v-flex
                            class="text-xs-left align-center"
                            style="font-weight: 800;"
                          >Contact</v-flex>
                          <v-flex fill-height class="child-flex d-flex">
                            <v-layout justify-end align-end fill-height>
                              <router-link style="text-decoration:none" :to="openManageContactsRoute()">EDIT</router-link>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout justify-start row>
                          <v-flex style="text-align: left; font-size: 12px;" class="pr-1">
                            <template v-for="contact in account.contacts">
                              <span
                                :key="contact.index"
                                v-if="contact.SICONTACTTYPEID === contactType"
                              >
                                <div style="margin-top:4px">
                                  <strong>{{ contact.ACNAME1 + ' ' + (contact.ACNAME2 ? contact.ACNAME2 : '') }}</strong>
                                </div>

                                <v-layout row v-if="contact.ACPHONE">
                                  <br />
                                  <v-flex shrink>Phone Number:</v-flex>&nbsp;
                                  <v-flex
                                    class="font-weight-bold"
                                  >{{contact.ACPHONE}} {{ contact.ACPHONEEXTENSION ? 'x' + contact.ACPHONEEXTENSION : '' }}</v-flex>
                                </v-layout>

                                <v-layout row v-if="contact.ACALTPHONE">
                                  <br />
                                  <v-flex shrink>Alt. Phone Number:</v-flex>&nbsp;
                                  <v-flex
                                    class="font-weight-bold"
                                  >{{contact.ACALTPHONE}} {{ contact.ACALTPHONEEXT ? 'x' + contact.ACALTPHONEEXT : '' }}</v-flex>
                                </v-layout>

                                <v-layout row v-if="contact.ACMOBILEPHONE">
                                  <br />
                                  <v-flex shrink>Cell Number:</v-flex>&nbsp;
                                  <v-flex class="font-weight-bold">{{contact.ACMOBILEPHONE}}</v-flex>
                                </v-layout>

                                <v-layout row v-if="contact.SILANGUAGENAME">
                                  <br />
                                  <v-flex shrink>Language:</v-flex>&nbsp;
                                  <v-flex class="font-weight-bold">{{contact.SILANGUAGENAME}}</v-flex>
                                </v-layout>

                                <v-layout row v-if="contact.ACEMAIL">
                                  <br />
                                  <v-flex shrink>Email:</v-flex>&nbsp;
                                  <v-flex >
                                    <a
                                      style="text-decoration: none"
                                      :href="'mailto:'+contact.ACEMAIL"
                                    >{{contact.ACEMAIL.toUpperCase()}}</a>
                                  </v-flex>
                                </v-layout>
                              </span>
                            </template>
                          </v-flex>

                          <v-flex class="child-flex pl-3" xs4>
                            <v-layout justify-end>
                              <v-select
                                class="caption"
                                :items="account.ddlContactTypes"
                                v-model="contactType"
                                item-text="Text"
                                item-value="Value"
                                label="Contact Type"
                              ></v-select>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <!-- END OF TOP 2ND COLUMN -->
                      <!-- START OF TOP 3RD COLUMN -->
                      <v-flex justify-start mr-5 xs2 style="margin-right: 50px;">
                        <v-layout
                          style="border-bottom: 1px solid #E0E0E0; padding-top:7px;padding-bottom:2px"
                        >
                          <v-flex
                            class="text-xs-left align-center"
                            style="font-weight: 800;"
                          >Bill Options</v-flex>
                          <v-flex fill-height class="child-flex d-flex">
                            <v-layout justify-end align-end fill-height>
                              <router-link style="text-decoration:none" :to="openEditAccountRoute()">EDIT</router-link>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex
                            class="text-xs-left"
                            style="font-size: 12px; min-height: 126px; margin-top:4px;"
                          >
                            <v-layout row v-if="account.invoiceCycle">
                              <br />
                              <v-flex xs7>Invoice Cycle:</v-flex>
                              <v-flex
                                class="font-weight-bold text-xs-right"
                              >{{account.invoiceCycle}}</v-flex>
                            </v-layout>

                            <v-layout row v-if="account.billLanguage">
                              <br />
                              <v-flex xs7>Language:</v-flex>
                              <v-flex
                                class="font-weight-bold text-xs-right"
                              >{{account.billLanguage}}</v-flex>
                            </v-layout>

                            <v-layout row v-if="account.billDeliveryMethod">
                              <br />
                              <v-flex xs7>Delivery Method:</v-flex>
                              <v-flex
                                class="font-weight-bold text-xs-right"
                              >{{account.billDeliveryMethod}}</v-flex>
                            </v-layout>

                            <v-layout row v-if="account.billManagementReport">
                              <br />
                              <v-flex xs7>Management Report:</v-flex>
                              <v-flex
                                class="font-weight-bold text-xs-right"
                              >{{account.billManagementReport}}</v-flex>
                            </v-layout>

                            <v-layout row v-if="account.billCallDetailReport">
                              <br />
                              <v-flex xs7>Call Detail Report:</v-flex>
                              <v-flex
                                class="font-weight-bold text-xs-right"
                              >{{account.billCallDetailReport}}</v-flex>
                            </v-layout>
                            <v-layout row v-if="account.paymentMethod">
                              <br />
                              <v-flex xs7>Pay By:</v-flex>
                              <v-flex
                                class="font-weight-bold text-xs-right"
                              >{{account.paymentMethod}}</v-flex>
                            </v-layout>

                            <v-layout row v-if="account.interest">
                              <br />
                              <v-flex xs7>Interest:</v-flex>
                              <v-flex class="font-weight-bold text-xs-right">{{account.interest}}</v-flex>
                            </v-layout>

                            <v-layout row v-if="account.creditTerm">
                              <br />
                              <v-flex xs7>Credit Term:</v-flex>
                              <v-flex class="font-weight-bold text-xs-right">{{account.creditTerm}}</v-flex>
                            </v-layout>

                            <v-layout row v-if="account.creditLimit">
                              <br />
                              <v-flex xs7>Credit Limit:</v-flex>
                              <v-flex
                                class="font-weight-bold text-xs-right"
                              >${{numberWithCommas(account.creditLimit)}}</v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <!-- END OF TOP 3RD COLUMN -->

                      <!-- START OF TOP 4TH COLUMN -->
                      <v-flex justify-start xs3>
                        <v-layout
                          style="border-bottom: 1px solid #E0E0E0; padding-top:11px;padding-bottom:2px;font-size: 12px;"
                        >
                          <v-flex
                            class="text-xs-left align-center font-weight-black"
                          >Unbilled Usage Amount:</v-flex>
                          <v-flex fill-height class="child-flex d-flex">
                            <v-layout
                              justify-end
                              align-end
                              fill-height
                              font-weight-black
                            >{{ account.unbilled || account.unbilled === 0 ? formatCurrency(account.unbilled) : '' }}</v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout justify-start column>
                          <div style="text-align: left; font-size: 12px;  margin-top:4px;">
                            <template v-for="ardoc in account.docs">
                              <v-layout row :key="ardoc.index" v-show="ardoc.ARIDOCTYPE === 'IN'">
                                <v-layout>
                                  Invoice:
                                  <a
                                    style="padding-left: 3px;"
                                    @click="exportToPDF(ardoc.ARDOCID)"
                                  >{{ ardoc.formattedDate }}</a>
                                </v-layout>
                                <v-layout
                                  justify-end
                                >{{ ardoc.ARORIGAMOUNT || ardoc.ARORIGAMOUNT === 0 ? formatCurrency(ardoc.ARORIGAMOUNT) : '' }}</v-layout>
                              </v-layout>
                            </template>

                            <template v-for="ardoc in account.docs">
                              <v-layout row :key="ardoc.index" v-show="ardoc.ARIDOCTYPE === 'CA'">
                                <v-layout>Payment: {{ ardoc.formattedDate }}</v-layout>
                                <v-layout
                                  justify-end
                                  red--text
                                >{{ ardoc.ARORIGAMOUNT || ardoc.ARORIGAMOUNT === 0 ? formatCurrency(ardoc.ARORIGAMOUNT) : '' }}</v-layout>
                              </v-layout>
                            </template>

                            <v-layout row style="border-top: 1px solid #E0E0E0">
                              <v-layout font-weight-black>Balance:</v-layout>
                              <v-layout
                                justify-end
                                font-weight-black
                              >{{ account.balance || account.balance === 0 ? formatCurrency(account.balance) : '' }}</v-layout>
                            </v-layout>
                          </div>

                          <v-layout row>
                            <v-layout>
                              <router-link style="text-decoration: none" :to="goToReceivables()">ALL RECEIVABLES</router-link>
                            </v-layout>
                          </v-layout>
                        </v-layout>
                      </v-flex>
                      <!-- END OF TOP 4TH COLUMN -->
                    </v-layout>
                  </v-flex>
                </v-layout>
                <!-- END OF TOP PANEL -->
                <!-- START OF ACTIVE SERVICES -->
                <v-layout column mb-0 mt-1>
                  <v-layout justify-start row align-center mb-0>
                    <v-layout align-baseline>
                      <div
                        class="text-xs-left align-center"
                        style="font-size: 20px; font-weight: 600;"
                      >Active Services</div>
                      <router-link style="margin-left: 20px; text-decoration: none" :to="goToServices()">ALL SERVICES</router-link>
                      <router-link style="margin-left: 20px; text-decoration:none" :to="goToServiceLog()">LOG</router-link>
                    </v-layout>

                    <v-layout justify-end align-center>
                      <v-btn
                        class="TierButton"
                        style="max-width: 45%; margin-left: 30px; max-height: 22px; margin-right: 0px; margin-bottom: 0px;"
                        :to="openCreateServiceRoute()"
                      >+ New Service</v-btn>
                      <createService ref="createService" @parentRefresh="initialize"></createService>
                    </v-layout>
                  </v-layout>

                  <v-data-table
                    :headers="servicesHeaders"
                    :items="activeServices"
                    :items-per-page="3"
                    hide-actions
                    class="small-table striped-table"
                  >
                    <template slot="items" slot-scope="props">
                      <tr :key="props.index">
                        <td
                          class="text-xs-left px-0 caption"
                        >{{ props.item["ElementType"] + ' ' + props.item["ElementDescription"] }}</td>
                        <td class="text-xs-left px-0 caption">{{ props.item["Element"] }}</td>
                        <td class="text-xs-left px-0 caption">{{ props.item["ServiceType"] }}</td>
                        <td class="text-xs-left px-0 caption">
                          <a
                            class="mr-3"
                            style="text-decoration: none"
                            @click="openEditServiceForm(props.item)"
                          >{{ props.item["Provider"] }}</a>
                        </td>
                        
                        <td class="text-xs-left px-0 caption">{{ props.item["ServiceType"] === 'Wireless' && props.item["ElementType"] !="MDN" ? formatPN_helper(props.item["Element"]) : props.item["ElementType"] =="MDN"? formatSIM(props.item["Element"]): props.item["Element"] }}</td>
                        <td class="text-xs-left px-0 caption">{{ formatSIM(props.item["SecondaryIdentifier"]) }}</td>
                        
                        <td class="text-xs-left px-0 caption">{{ props.item["LastTx"] | formatDateTime }}</td>
                        <td class="text-xs-left px-0 caption">{{ props.item["Inter"] }}</td>
                        <td class="text-xs-left px-0 caption">{{ props.item["Intra"] }}</td>
                        <td class="text-xs-left px-0 caption">{{ props.item["Intl"] }}</td>
                        <td class="text-xs-left px-0 caption" :class="{'green--text': props.item.Status === 'Active', 'red--text': props.item.Status === 'Cancelled'}">{{ props.item["Status"] | uppercase }}</td>
                        <td class="justify-end align-center text-xs-right pr-0 pt-0 pb-0 caption">
                          <router-link
                            class="mr-0"
                            style="text-decoration: none"
                            :to="openEditServiceRoute(props.item)"
                          >EDIT</router-link>
                        </td>
                      </tr>
                    </template>

                    <template slot="footer">
                      <td class="text-xs-left pl-0 caption" colspan="12">
                        <strong>
                          Total
                          Records:
                        </strong>
                        {{ numberWithCommas(totalRecordsServices) }}
                      </td>
                    </template>
                  </v-data-table>
                  <editService ref="editService"></editService>
                </v-layout>
                <!-- END OF ACTIVE SERVICES -->
                <!-- START OF ACCOUNT LEVEL CHARGES -->
                <v-layout column mb-0>
                  <v-layout justify-start row align-center mt-3 mb-0>
                    <v-layout align-baseline>
                      <div
                        class="text-xs-left align-center"
                        style="font-size: 20px; font-weight: 600;"
                      >Account Level Charges</div>
                      <router-link style="margin-left: 20px; text-decoration: none" :to="goToCharges()">ALL CHARGES</router-link>
                      <router-link style="margin-left: 20px; text-decoration: none" :to="goToChargeLog()">LOG</router-link>
                    </v-layout>

                    <v-layout justify-end align-center>
                      <v-btn
                        class="TierButton"
                        style="max-width: 45%; margin-left: 30px; max-height: 22px;  margin-right: 0px; margin-bottom: 0px;"
                        :to="openCreateChargeRoute()"
                      >+ New Charge</v-btn>
                      <createCharge ref="createCharge" @parentRefresh="initialize"></createCharge>
                    </v-layout>
                  </v-layout>

                  <v-data-table
                    :headers="chargesHeaders"
                    :items="charges"
                    :items-per-page="3"
                    hide-actions
                    class="small-table striped-table"
                  >
                    <template slot="items" slot-scope="props">
                      <tr :key="props.index">
                        <td class="text-xs-left px-0 caption">{{ props.item["ChargeDescription"] }}</td>
                        <td
                          :class="{'justify-end text-xs-left pr-2 pt-0 pb-0': props.item.ChargeAmount >= 0, 'justify-end text-xs-left pr-2 pt-0 pb-0 red--text': props.item.ChargeAmount < 0}"
                        >{{ formatCurrency(props.item["ChargeAmount"]) }}</td>
                        <td
                          class="text-xs-left px-0 caption"
                        >{{ formatChargeDate(props.item["StartDate"]) }}</td>
                        <td
                          class="text-xs-left px-0 caption"
                        >{{ formatChargeDate(props.item["EndDate"]) }}</td>
                        <td class="text-xs-left px-0 caption" :class="{'purple--text': props.item.ChargeFrequency === 'Monthly', 'orange--text': props.item.ChargeFrequency === 'One-time'}">{{ props.item["ChargeFrequency"] | uppercase}}</td>
                        <td class="justify-end align-center text-xs-right pr-0 pt-0 pb-0 caption">
                          <router-link
                            class="mr-0"
                            style="text-decoration: none"
                            :to="openEditChargeRoute(props.item)"
                          >EDIT</router-link>
                        </td>
                      </tr>
                    </template>
                    <template slot="footer">
                      <td class="text-xs-left pl-0 caption" colspan="6">
                        <strong>
                          Total
                          Records:
                        </strong>
                        {{ numberWithCommas(totalRecordsCharges) }}
                      </td>
                    </template>
                  </v-data-table>
                </v-layout>
                <editCharge ref="editCharge"></editCharge>
                <!-- START OF TICKETS -->
                <v-layout column mb-0>
                  <v-layout justify-start row align-center mt-3 mb-0>
                    <v-layout align-baseline>
                      <div
                        class="text-xs-left align-center"
                        style="font-size: 20px; font-weight: 600;"
                      >Tickets</div>
                      <router-link style="margin-left: 20px; text-decoration:none" :to="openTickets()">ALL TICKETS</router-link>
                    </v-layout>

                    <v-layout justify-end align-center>
                      <v-btn
                        class="TierButton"
                        style="max-width: 45%; margin-left: 30px; max-height: 22px;  margin-right: 0px;  margin-bottom: 0px;"
                        :to="openCreateTicket()"
                      >+ New Ticket</v-btn>
                    </v-layout>
                  </v-layout>

                  <v-data-table
                    :headers="ticketsHeaders"
                    :items="tickets"
                    :items-per-page="3"
                    hide-actions
                    class="small-table striped-table"
                  >
                    <template slot="items" slot-scope="props">
                      <tr :key="props.index">
                        <td
                          class="text-xs-left px-0 caption"
                        >{{ props.item["OpenDate"] | formatDateTime}}</td>
                        <td class="text-xs-left px-0 caption">{{ props.item["Username"] }}</td>
                        <td class="text-xs-left px-0 caption">{{ props.item["Type"] }}</td>
                        <td
                          class="text-xs-left px-0 caption"
                        >{{ props.item.Details.length > 0? props.item.Details[0].ACDETAIL:"" }}</td>
                        <td
                          class="text-xs-left px-0 caption"
                          :class="[{'green--text': props.item.StatusId != 'A1' ? true : false},{'red--text': props.item.StatusId == 'A1' ? true : false} ]"
                        >{{ props.item.StatusId == 'A1' ? "OPEN" : "CLOSED"}}</td>
                        <td class="justify-end align-center text-xs-right pr-0 pt-0 pb-0 caption">
                          <router-link
                            class="mr-0 ml-2"
                            v-if="props.item.StatusId == 'A1'"
                            style="text-decoration: none"
                            :to="openEditTicket(props.item)"
                          >EDIT</router-link>
                          <!-- <a
                          v-if="props.item.StatusId == 'A1'"
                          class="mr-0"
                          style="text-decoration: none"
                          @click="openEditTicketForm(props.item).then(()=>{$vuetify.goTo('#createTicket')})"
                          >EDIT</a>-->
                          <a
                            class="mr-0"
                            v-if="props.item.StatusId == 'A2'"
                            style="text-decoration: none"
                            @click="reopenTicket(props.item)"
                          >REOPEN</a>
                        </td>
                      </tr>
                    </template>
                    <template slot="footer">
                      <td class="text-xs-left pa-0 caption" colspan="6">
                        <strong>
                          Total
                          Records:
                        </strong>
                        {{ numberWithCommas(totalRecordsTickets) }}
                      </td>
                    </template>
                  </v-data-table>
                </v-layout>
                <!-- END OF TICKETS -->
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-page>
</template>

<script>
import VPage from "../../layouts/Default.vue";
import axios from "axios";
import * as helper from "../../helpers/global.js";
import moment from "moment";
import editAccount from "./EditAccount";
import manageContacts from "./ManageContacts";
import auditLogDetails from "../Log/LogDetails.vue";
import createService from "../Services/CreateService";
import createCharge from "../Charges/CreateCharge";
import editCharge from "../Charges/EditCharge";
import editService from "../Services/EditService";
import "@/assets/css/main.css"

export default {
  name: "AccountSummary",

  components: {
    VPage,
    editAccount,
    manageContacts,
    auditLogDetails,
    createService,
    createCharge,
    editCharge,
    editService
  },

  data: () => ({
    dialog: false,
    search: "",
    loading: true,

    totalRecordsServices: 0,
    totalRecordsCharges: 0,
    totalRecordsTickets: 0,
    totalRecordsAuditLog: 0,

    BAN: "",

    contactType: "BT",

    breadcrumb: [
      {
        text: "Accounts",
        disabled: false,
        href: "#/accounts/all"
      },
      {
        text: "",
        disabled: true,
        href: "#/account-summary"
      }
    ],

    account: {},

    servicesHeaders: [
      {
        text: "Element/Type",
        value: "ElementType",
        sortable: false,
        width: "9%",
        fixed: true,
        align: "left",
        class: "pa-0 font-weight-bold body-2 sort-asc"
      },
      {
        text: "Element",
        value: "Element",
        sortable: false,
        width: "8%",
        fixed: true,
        align: "left",
        class: "pa-0 font-weight-bold body-2 sort-asc"
      },
      {
        text: "Svc. Type",
        value: "SvcType",
        sortable: false,
        width: "6%",
        fixed: true,
        align: "left",
        class: "pa-0 font-weight-bold body-2 sort-asc"
      },
      {
        text: "Provider",
        value: "Provider",
        sortable: false,
        width: "8%",
        fixed: true,
        align: "left",
        class: "pa-0 font-weight-bold body-2 sort-asc"
      },
      {
        text: "Service ID",
        value: "Element",
        // sortable: false,
        width: "9%",
        fixed: true,
        align: "left",
        class: "pa-0 font-weight-bold body-2 sort-asc"
      },
      {
        text: "Secondary ID",
        value: "SecondaryIdentifier",
        // sortable: false,
        width: "15%",
        fixed: true,
        align: "left",
        class: "pa-0 font-weight-bold body-2 sort-asc"
      },
      {
        text: "Last Tx",
        value: "LastTx",
        sortable: false,
        width: "12%",
        fixed: true,
        align: "left",
        class: "pa-0 font-weight-bold body-2 sort-asc"
      },
      {
        text: "Rate Plan (Inter)",
        value: "Inter",
        sortable: false,
        width: "9%",
        fixed: true,
        align: "left",
        class: "pa-0 font-weight-bold body-2 sort-asc"
      },
      {
        text: "Rate Plan (Intra)",
        value: "Intra",
        sortable: false,
        width: "9%",
        fixed: true,
        align: "left",
        class: "pa-0 font-weight-bold body-2 sort-asc"
      },
      {
        text: "Rate Plan (Intl)",
        value: "Intl",
        sortable: false,
        width: "9%",
        fixed: true,
        align: "left",
        class: "pa-0 font-weight-bold body-2 sort-asc"
      },
      {
        text: "Status",
        value: "Status",
        sortable: false,
        width: "9%",
        fixed: true,
        align: "left",
        class: "pa-0 font-weight-bold body-2 sort-asc"
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "5%",
        fixed: true,
        align: "right",
        class: "pa-0 font-weight-bold body-2 sort-asc"
      }
    ],

    chargesHeaders: [
      {
        text: "Description",
        value: "ChargeDescription",
        sortable: false,
        width: "18%",
        fixed: true,
        align: "left",
        class: "pa-0 font-weight-bold body-2 sort-asc"
      },
      {
        text: "Amount",
        value: "ChargeAmount",
        sortable: false,
        width: "18%",
        fixed: true,
        align: "left",
        class: "pa-0 font-weight-bold body-2 sort-asc"
      },
      {
        text: "Effective Date",
        value: "StartDate",
        sortable: false,
        width: "18%",
        fixed: true,
        align: "left",
        class: "pa-0 font-weight-bold body-2 sort-asc"
      },
      {
        text: "End Date",
        value: "EndDate",
        sortable: false,
        width: "18%",
        fixed: true,
        align: "left",
        class: "pa-0 font-weight-bold body-2 sort-asc"
      },
      {
        text: "Frequency",
        value: "ChargeFrequency",
        sortable: false,
        width: "18%",
        fixed: true,
        align: "left",
        class: "pa-0 font-weight-bold body-2 sort-asc"
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "10%",
        fixed: true,
        align: "right",
        class: "pa-0 font-weight-bold body-2 sort-asc"
      }
    ],

    ticketsHeaders: [
      {
        text: "Timestamp",
        value: "Timestamp",
        sortable: false,
        width: "15%",
        fixed: true,
        align: "left",
        class: "pa-0 font-weight-bold body-2 sort-asc"
      },
      {
        text: "User",
        value: "User",
        sortable: false,
        width: "10%",
        fixed: true,
        align: "left",
        class: "pa-0 font-weight-bold body-2 sort-asc"
      },
      {
        text: "Comment/Ticket Type",
        value: "TicketType",
        sortable: false,
        width: "15%",
        fixed: true,
        align: "left",
        class: "pa-0 font-weight-bold body-2 sort-asc"
      },
      {
        text: "Latest Note",
        value: "ACDETAIL",
        sortable: false,
        width: "55%",
        fixed: true,
        align: "left",
        class: "pa-0 font-weight-bold body-2 sort-asc"
      },
      {
        text: "Status",
        value: "StatusId",
        sortable: false,
        width: "15%",
        fixed: true,
        align: "left",
        class: "pa-0 font-weight-bold body-2 sort-asc"
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "10%",
        fixed: true,
        align: "right",
        class: "pa-0 font-weight-bold body-2 sort-asc"
      }
    ],

    logsHeaders: [
      {
        text: "Timestamp",
        value: "Timestamp",
        sortable: false,
        width: "25%",
        fixed: true,
        align: "left",
        class: "pa-0 font-weight-bold body-2 sort-asc"
      },
      {
        text: "User",
        value: "Username",
        sortable: false,
        width: "20%",
        fixed: true,
        align: "left",
        class: "pa-0 font-weight-bold body-2 sort-asc"
      },
      {
        text: "Message",
        value: "Message",
        sortable: false,
        width: "25%",
        fixed: true,
        align: "left",
        class: "pa-0 font-weight-bold body-2 sort-asc"
      },

      {
        text: "Details",
        value: "Details",
        sortable: false,
        width: "20%",
        fixed: true,
        align: "left",
        class: "pa-0 font-weight-bold body-2 sort-asc"
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "10%",
        fixed: true,
        align: "right",
        class: "pa-0 font-weight-bold body-2 sort-asc"
      }
    ],

    activeServices: [],

    charges: [],

    tickets: [
      // {
      //   Timestamp: "2014-01-07 10:43:52 PM",
      //   User: "sdunaway",
      //   TicketType: "Billing/Accounting"
      // },
      // {
      //   Timestamp: "2014-01-07 10:43:52 PM",
      //   User: "sdunaway",
      //   TicketType: "Billing/Accounting"
      // },
      // {
      //   Timestamp: "2014-01-07 10:43:52 PM",
      //   User: "sdunaway",
      //   TicketType: "Billing/Accounting"
      // }
    ],

    logs: [
      // {
      //   Message: "Account Updated",
      //   Timestamp: "2014-01-07 10:43:52 PM",
      //   Username: "marzuk.kabir@elabsinc.com",
      //   Details: "Payment Method"
      // },
      // {
      //   Message: "Account Updated",
      //   Timestamp: "2014-01-07 10:43:52 PM",
      //   Username: "marzuk.kabir@elabsinc.com",
      //   Details: "Delivery Method"
      // },
      // {
      //   Message: "Account Updated",
      //   Timestamp: "2014-01-07 10:43:52 PM",
      //   Username: "marzuk.kabir@elabsinc.com",
      //   Details: "Account Name"
      // }
    ]
  }),
  filters: {
    formatDateTime: function(date) {
      if (
        moment(date, "YYYY-MM-DDTHH:mm:ss", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.S", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SS", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SSS", true).isValid()
      ) {
        return moment(date, "YYYY-MM-DDTHH:mm:ss").format(
          "YYYY/MM/DD h:mm:ss A"
        );
      }
    },
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    uppercase: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    }
  },

  mounted() {
    this.initialize();
    this.$root.$on("initialize", this.initialize);
  },

  destroyed() {
    this.$root.$off("initialize", this.initialize);
  },
   beforeRouteUpdate (to, from, next) {
    if (to.path== from.path) {
       this.checkQueryStringModals(to.query)
       
    }
     this.$nextTick(() => { if (to.name == from.name){
      if (to.params.BAN !== from.params.BAN){
        this.BAN = to.params.BAN
         this.initialize()
      }
    }})
      next()
  },
  

  methods: {
    async initialize() {
      this.BAN = this.$route.params.BAN;
      this.breadcrumb[1].text = this.BAN;

      await this.getAccountInfo(
        "api/Account/GetAccountSummaryInfo/" + this.BAN,
        "account"
      );
      await this.getAccountAR();
      await this.getAccountServices();
      await this.getAccountCharges();
      await this.getAccountTickets();

      this.formatARDocsDates();
      // this.formatServicesDates();

      if (this.account.PhoneNumberType === "N") {
        this.formatPhoneNumbers();
      }
      this.checkQueryStringModals(this.$route.query)
      //this.$refs.spinner.spinOff();
    },
    checkQueryStringModals(query){
      if (query.ChargeId != null) {
              var ChargeId = query.ChargeId;
              this.openEditChargeForm({
                ChargeId: ChargeId
              });
            }
      if (query.createCharge != null) {
        this.openCreateChargeForm();
      }
       if (query.ServiceId != null) {
        var serviceId = query.ServiceId;
        this.openEditServiceForm({
          ServiceId: serviceId
        });
      }
       if (query.createService != null ) {
        this.openCreateServiceForm();
      }
      if (query.BAN != null) {
        var BAN = this.$route.query.BAN;
        this.openEditAccountForm({
          BAN: BAN
        });
      }
      if (query.manageContacts != null ) {
        this.openManageContactsForm();
      }
    },

    // Get account info from DB to populate page
    async getAccountInfo(url, obj) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data))
        .catch(err => console.log(err));
    },

    async getAccountAR() {
      // Get 3 newest invoices and payments and account balance
      await axios
        .get("api/Receivables/GetAccountSummaryARInfo/" + this.BAN)
        .then(response => {
          this.account.docs = response.data.docs;
          this.account.balance = response.data.accountBalance;
        });
    },

    async getAccountServices() {
      await axios
        .get("/api/Services/GetActiveAccountServices/" + this.BAN + "/8")
        .then(response => {
          this.activeServices = response.data.services;
          this.totalRecordsServices = response.data.countAllAccountServices;
          this.account.unbilled = response.data.unbilledAmount;
        });
      this.loading = false;
    },

    // Get 2 newest account level charges to display on account summary page
    async getAccountCharges() {
      var pagination = {
        page: 1,
        rowsPerPage: 3,
        totalRecords: 0,
        sortBy: "StartDate",
        descending: true
      };
      var filters = {
        AccountNumber: this.BAN,
        ServiceType: "Account"
      };
      await axios
        .post(
          "/api/Charge/GetPagedChargeList/",
          {
            postData: {
              pagination: pagination,
              filtersChanged: true,
              filters: filters
            }
          },
          {
            headers: {
              "Content-type": "application/json"
            }
          }
        )
        .then(response => {
          this.charges = response.data.charges;
          this.totalRecordsCharges = response.data.totalRecords;
        });
    },
    async getAccountLog() {
      var pagination = {
        page: 1,
        rowsPerPage: 3,
        totalRecords: 0,
        sortBy: "Timestamp",
        descending: true
      };
      var filters = {
        AccountBAN: this.BAN
      };
      await axios
        .post(
          "/api/AuditLogs/GetPagedLogList/",
          {
            postData: {
              pagination: pagination,
              filtersChanged: true,
              filters: filters
            }
          },
          {
            headers: {
              "Content-type": "application/json"
            }
          }
        )
        .then(response => {
          this.logs = response.data.AccountLog;
          this.totalRecordsAuditLog = response.data.pagination.totalRecords;
        });
    },
    async getAccountTickets() {
      var pagination = {
        page: 1,
        rowsPerPage: 3,
        totalRecords: 0,
        sortBy: "Date",
        descending: true
      };
      var filters = {
        AccountBAN: this.BAN
      };
      await axios
        .post(
          "/api/Tickets/GetPagedTicketList/",
          {
            postData: {
              pagination: pagination,
              filtersChanged: true,
              filters: filters
            }
          },
          {
            headers: {
              "Content-type": "application/json"
            }
          }
        )
        .then(response => {
          this.tickets = response.data.tickets;
          this.totalRecordsTickets = response.data.pagination.totalRecords;
        });
    },

    // Formatter for charge dates
    formatChargeDate(value) {
      if (value) return moment(value).format("YYYY-MM-DD");
      else return "";
    },

    formatCurrency(value) {
      var absValue = Math.abs(value);
      var returnString = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      }).format(absValue);

      return value < 0 ? "(" + returnString + ")" : returnString;
    },

    // Get data for elements in component
    async getElementData(url, obj) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data[`${obj}`]))
        .catch(err => console.log(err));
    },

    formatARDocsDates() {
      this.account.docs = this.account.docs.map(doc => ({
        ...doc,
        formattedDate: new moment(doc.ARDOCDATE).format("MMM DD, YYYY")
      }));
    },
    formatServicesDates() {
      this.activeServices = this.activeServices.map(service => ({
        ...service,
        formattedLastTx: new moment(service.LastTx).format(
          "DD/MM/YYYY h:mm:ss A"
        )
      }));
    },

    formatPhoneNumbers() {
      this.account.contacts.forEach(contact => {
        contact.ACPHONE = contact.ACPHONE
          ? this.formatPN_helper(contact.ACPHONE)
          : null;
        contact.ACMOBILEPHONE = contact.ACMOBILEPHONE
          ? this.formatPN_helper(contact.ACMOBILEPHONE)
          : null;
        contact.ACALTPHONE = contact.ACALTPHONE
          ? this.formatPN_helper(contact.ACALTPHONE)
          : null;
      });
    },
    formatPN_helper(num) {
      let formattedNum =
        "(" + num.slice(0, 3) + ") " + num.slice(3, 6) + "-" + num.slice(6);
      return formattedNum;
    },
    formatSIM(num) {
      if (num){
        let res = [...num].map((d, i) => (i) % 5 == 0 ? ' ' + d : d).join('').trim()
      return res;
      }
    },

     goToParent() {
      return "/account-summary/" + this.account.pan;
    },
    

     goToChild() {
      if (this.account.childAccounts.length === 1) {
        return "/account-summary/" + this.account.childAccounts[0]
    
      } else {
        return "/accounts/" + this.BAN
      }
    },

    goToReceivables() {
      return "/receivables/" + this.BAN;
    },

   goToServices() {
      return "/services/" + this.BAN;
    },

   goToCharges() {
      return "/charges/" + this.BAN;
    },
     goToServiceLog(){
      return "/log/service/"+this.BAN+"/all/all"
    },
    goToChargeLog(){
      return "/log/charge/"+this.BAN+"/all/all"
    },

    async openEditAccountForm() {
     await this.$refs.editAccount.open({ BAN: this.BAN });
      this.deleteQueryString('BAN')
    },
    openEditAccountRoute(){
      var route = Object.assign({}, this.$route)
      var path = route.path
      var query = route.query

      var newQuery = Object.assign({}, query)
      newQuery.BAN = this.BAN
      return {path: path, query: newQuery}
    },

    // openEditServiceForm(item) {
    //   this.$router.push("/services/" + this.BAN + "?ServiceId=" + item);
    // },

    openManageContactsForm() {
      this.$refs.manageContacts.open({
        BAN: this.BAN,
        phoneNumberType: this.account.PhoneNumberType,
        Name1: this.account.Name1,
        Name2: this.account.Name2
      });
      this.deleteQueryString('manageContacts')
    },
    openManageContactsRoute(){
      var route = Object.assign({}, this.$route)
      var path = route.path
      var query = route.query

      var newQuery = Object.assign({}, query)
      newQuery.manageContacts = this.BAN
      return {path: path, query: newQuery}
    },
    openAuditLogs() {
      return "/log/account/" + this.BAN + "/all/all";
    },
    openTickets() {
      return "/tickets/" + this.BAN;
    },
    openCreateTicket() {
      return "/tickets/" + this.BAN + "?newTicket=true";
    },
    openEditTicket(item) {
      return "/tickets/" + this.BAN + "?ticketId=" + item.TicketId;
    },

    formatDetails_helper(arrayDetails) {
      var details = "";
      arrayDetails.forEach((value, index) => {
        details += value.ACCOLUMNNAME + ", ";
      });
      var detailsTrim = details.replace(/,\s*$/, "");
      return detailsTrim;
    },
    openAuditDetails(auditLog) {
      this.$refs.auditLogDetails.openAccountAuditLogDetails(auditLog.ACSTAT);
    },
    async openCreateServiceForm() {
      await this.$refs.createService.open({ BAN: this.BAN });
      this.deleteQueryString('createService')
    },
    async openEditServiceForm(item) {
      await this.$refs.editService.open({
        Id: item.ServiceId,
        BAN: item.AccountBAN,
        ElementType: item.ElementType,
        Description: item.ElementDescription,
        Service: item.ServiceType,
        Provider: item.Provider
      });
      this.deleteQueryString('ServiceId')
    },
    openEditServiceRoute(item){
      var route = Object.assign({}, this.$route)
      var path = route.path
      var query = route.query

      var newQuery = Object.assign({}, query)
      newQuery.ServiceId = item.ServiceId
      return {path: path, query: newQuery}
    },
     openCreateServiceRoute(){
      var route = Object.assign({}, this.$route)
      var path = route.path
      var query = route.query

      var newQuery = Object.assign({}, query)
      newQuery.createService = this.BAN
      return {path: path, query: newQuery}
    },
    async openCreateChargeForm() {
      await this.$refs.createCharge.open({ BAN: this.BAN });
      this.deleteQueryString('createCharge')
    },
     openCreateChargeRoute(item){
      var route = Object.assign({}, this.$route)
      var path = route.path
      var query = route.query

      var newQuery = Object.assign({}, query)
      newQuery.createCharge = this.BAN
      return {path: path, query: newQuery}
    },
    async openEditChargeForm(item) {
      await this.$refs.editCharge.open({
        ChargeId: item.ChargeId.toString()
      });
      this.deleteQueryString('ChargeId')
    },
    openEditChargeRoute(item){
      var route = Object.assign({}, this.$route)
      var path = route.path
      var query = route.query

      var newQuery = Object.assign({}, query)
      newQuery.ChargeId = item.ChargeId
      return {path: path, query: newQuery}
    },
    numberWithCommas(x) {
      var parts = x.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    },
    exportToPDF(item) {
      // this.$refs.spinner.spinOn();
      axios({
        url: "/api/Receivables/DownloadPDF/" + item,
        method: "GET",
        responseType: "blob"
      })
        .then(response => {
          var accountBAN = this.padLeadingZeros(this.BAN, 12);
          var docId = this.padLeadingZeros(item, 10);

          var filename = accountBAN + docId;
          var currentDate = moment().format("YYYYMMDD.HHmm");
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename + ".pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();

          var blob = new window.Blob([response.data], {
            type: "application/pdf"
          });
          var fileURL = URL.createObjectURL(blob);
          var win = window.open();
          win.document.write(
            '<iframe src="' +
              fileURL +
              '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
          );
          // this.$refs.spinner.spinOff();
        })
        .catch(err => {
          // this.$refs.spinner.spinOff();
        });
    },
    padLeadingZeros(num, size) {
      var s = "000000000000000" + num;
      return s.substr(s.length - size);
    },
    async reopenTicket(item) {
      var message =
        "Are you sure you would like to reopen Ticket #" + item.TicketId + "?";
      var confirmReopen = confirm(message);
      var detail = "Ticket Reopened";
      var status = "A1";
      if (confirmReopen == true) {
        var ticket = {
          AccountNumber: item.AccountBAN,
          TicketId: item.TicketId,
          TypeId: item.TypeId,
          Status: "A1",
          Detail: detail
        };
        var result = await axios.post("api/Tickets/AddTicketDetail", ticket);
        let ticketStatusResult = await axios
          .post("api/Tickets/UpdateTicketStatus", ticket)
          .then(res => {
            this.initialize();
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    async updateStatusAction(val) {
      await this.$nextTick(() => {
        if (val != "S0") {
          var confirmUpdateStatus = confirm(
            "Are you sure you would like to change the status of the account?"
          );

          if (confirmUpdateStatus == true) {
            var BAN = this.BAN;
            var ActionStatusId = val;
            axios
              .get("/api/Account/UpdateStatus/" + BAN + "/" + ActionStatusId)
              .then(res => {
                console.log(res.data);
                this.initialize();
              });
          } else if (confirmUpdateStatus == false) {
            this.account.statusAction = "S0";
            // this.account.splice()
          }
        }
      });
    },
    formatCurrency(value) {
      var absValue = Math.abs(value);
      var returnString = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      }).format(absValue);

      return value < 0 ? "(" + returnString + ")" : returnString;
    },
    deleteQueryString(queryString){
      let query = Object.assign({}, this.$route.query);
      delete query[`${queryString}`];
      this.$router.replace({ query });
    },
  }
};
</script>

<style scoped>
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}
/deep/table.v-table tfoot tr {
  height: 22px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
</style>
